import React, { lazy } from "react";
import "./main.scss";
import BodyContainer from "./BodyContainer";
import { HeaderBar } from "../components/NavigationBar/HeaderBar";
import withMemo from "../components/HOC/withMemo";

const NavigationBarWrapper = lazy(() => import("../components/NavigationBar/NavigationBarWrapper"));

const Main = () => {
  const MemoizedNavigationBarWrapper = withMemo(NavigationBarWrapper);
  return (
    <div className="app-layout">
      <div className="main-wrapper">
        <HeaderBar />
        <MemoizedNavigationBarWrapper className="displayWrapper" />
      </div>

      <div className="main-container">
        <BodyContainer />
      </div>
    </div>
  );
}

export default Main;
